import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { forgotPassword } from '../services/auth'
import { EnvelopeIcon } from '@heroicons/react/24/outline'
import Logo from '../asset/images/logo.svg'

const ForgotPasswordPage = () => {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')

  const onSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError('')
    setMessage('')
    const res = await forgotPassword({ email })
    setLoading(false)
    if (res.status === 200) {
      setMessage('If the email exists, a reset link has been sent.')
    } else {
      setError(res.error || 'Could not send reset link')
    }
  }

  return (
    <div className="min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8 bg-slate-50 font-sans">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <Link to="/" className="flex justify-center items-center gap-1.5 mb-8 group">
          <img
            src={Logo}
            alt="Obule"
            className="h-10 w-auto object-contain transition-transform duration-500 group-hover:scale-110"
          />
          <span className="text-3xl font-semibold tracking-wide text-slate-900">
            bule
          </span>
        </Link>
        <div className="text-center">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900">
            Reset your password
          </h2>
          <p className="mt-2 text-sm text-slate-600">
            Enter your email to receive a reset link
          </p>
        </div>
      </div>

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white px-6 py-10 shadow-xl border border-slate-100 sm:rounded-2xl sm:px-12">
          <form className="space-y-6" onSubmit={onSubmit}>
            {error && (
              <div className="rounded-lg bg-red-50 p-4 border border-red-100 flex items-start gap-3 text-red-700 font-medium text-sm">
                <p>{error}</p>
              </div>
            )}
            {message && (
              <div className="rounded-lg bg-green-50 p-4 border border-green-100 flex items-start gap-3 text-green-700 font-medium text-sm">
                <p>{message}</p>
              </div>
            )}

            <div>
              <label htmlFor="email" className="block text-sm font-semibold leading-6 text-slate-900">
                Email address
              </label>
              <div className="relative mt-2">
                <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                  <EnvelopeIcon className="h-5 w-5 text-slate-400" aria-hidden="true" />
                </div>
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  placeholder="name@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="block w-full rounded-lg border-0 py-2.5 pl-10 text-slate-900 shadow-sm ring-1 ring-inset ring-slate-300 placeholder:text-slate-400 focus:ring-2 focus:ring-inset focus:ring-cyan-600 sm:text-sm sm:leading-6 transition-all"
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                disabled={loading}
                className="flex w-full justify-center rounded-lg bg-cyan-600 px-3 py-2.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-cyan-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-600 transition-all disabled:opacity-70 disabled:cursor-not-allowed hover:shadow-md hover:-translate-y-0.5 transform duration-200"
              >
                {loading ? 'Sending...' : 'Send reset link'}
              </button>
            </div>

            <div className="text-center text-sm text-slate-500">
              Remember your password?{' '}
              <Link to="/login" className="font-semibold text-cyan-600 hover:text-cyan-500">
                Log in
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default ForgotPasswordPage
